import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { EventService } from "@core/services/event.service";
import { Observable } from "rxjs";

@Injectable()
export class EventResolver implements Resolve<any> {
  private readonly eventServce = inject(EventService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.eventServce.resolverEvent();
  }
}
